import React from 'react';
import { AlertTriangleIcon, SkullIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 bg-dark-950 relative border-y border-cyan-900/30" data-id="element-596">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-597">
        <div className="text-center mb-10" data-id="element-598">
          <SkullIcon className="w-12 h-12 text-red-500 mx-auto mb-4 opacity-80" data-id="element-599" />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-600">
            The era of "Prompt Engineering" is{' '}
            <span className="text-red-500" data-id="element-601">DEAD</span>.
          </h2>
          <p className="text-xl text-gray-400" data-id="element-602">
            Stop selling AI writing like a cheap commodity and start owning the
            technical architecture of 2026.
          </p>
        </div>

        <div className="mb-8 bg-amber-500/10 border border-amber-500/30 rounded-lg p-6 text-center" data-id="element-603">
          <AlertTriangleIcon className="w-8 h-8 text-amber-500 mx-auto mb-3" data-id="element-604" />
          <h3 className="text-xl font-bold text-amber-500 mb-1 tracking-wide" data-id="element-605">
            THE MARKET SPLIT IS HAPPENING NOW
          </h3>
          <p className="text-amber-400/80" data-id="element-606">Which side are you building on?</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-607">
          <div className="bg-dark-900 border border-red-900/30 p-8 rounded-lg relative overflow-hidden group" data-id="element-608">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500" data-id="element-609"></div>
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-610">
              <span className="text-red-500 line-through" data-id="element-611">The Commodity</span>
            </h3>
            <ul className="space-y-4 text-gray-400" data-id="element-612">
              <li className="flex items-start gap-3" data-id="element-613">
                <span className="text-red-500 mt-1" data-id="element-614">✕</span>
                Manually "prompting" blog posts
              </li>
              <li className="flex items-start gap-3" data-id="element-615">
                <span className="text-red-500 mt-1" data-id="element-616">✕</span>
                Copying-and-pasting into Google Docs
              </li>
              <li className="flex items-start gap-3" data-id="element-617">
                <span className="text-red-500 mt-1" data-id="element-618">✕</span>
                Chasing clients for $50 an article
              </li>
              <li className="flex items-start gap-3" data-id="element-619">
                <span className="text-red-500 mt-1" data-id="element-620">✕</span>
                Competing against millions willing to work for $5/hour
              </li>
            </ul>
          </div>

          <div className="bg-dark-900 border border-cyan-500/30 p-8 rounded-lg relative overflow-hidden box-glow" data-id="element-621">
            <div className="absolute top-0 left-0 w-1 h-full bg-cyan-400" data-id="element-622"></div>
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-623">
              <span className="text-cyan-400" data-id="element-624">The Architect</span>
            </h3>
            <ul className="space-y-4 text-gray-300" data-id="element-625">
              <li className="flex items-start gap-3" data-id="element-626">
                <span className="text-cyan-400 mt-1" data-id="element-627">✓</span>
                Treating AI as Infrastructure, not a toy
              </li>
              <li className="flex items-start gap-3" data-id="element-628">
                <span className="text-cyan-400 mt-1" data-id="element-629">✓</span>
                Building a system designed to scale without you
              </li>
              <li className="flex items-start gap-3" data-id="element-630">
                <span className="text-cyan-400 mt-1" data-id="element-631">✓</span>
                Selling OUTCOMES, not prompts
              </li>
              <li className="flex items-start gap-3" data-id="element-632">
                <span className="text-cyan-400 mt-1" data-id="element-633">✓</span>
                Automating lead gen, creation, and distribution
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center space-y-2 mt-12" data-id="element-634">
          <p className="text-lg text-gray-300" data-id="element-635">The Commodity sells hours.</p>
          <p className="text-lg text-gray-300" data-id="element-636">
            The Architect sells infrastructure.
          </p>
          <p className="text-xl font-bold text-cyan-400 mt-4" data-id="element-637">
            One has a ceiling. One doesn't.
          </p>
        </div>
      </div>
    </section>;
}